import { Container } from "../Container/Container";
import { timeout } from "../../../../HA";

export class Navigation extends Container {
    public getTagName(): string {
        return "nav";
    }

    protected initialize(data: any) {
        super.initialize(data);
        const color = this.translate("#bgColor");
        const useTransparent = this.translate("#useTransparent");
        if (color && useTransparent) {
            timeout(() => {
                const nav = document.querySelector('nav') as HTMLElement;
                if (!nav) { return; }
                window.addEventListener('scroll', (event) => {
                    event.preventDefault();
                    nav.style.backgroundColor = window.scrollY <= window.innerHeight ? 'transparent' : color;
                });
                nav.style.backgroundColor = 'transparent';
            }, 200);
        } else if (color) {
            timeout(() => {
                const nav = document.querySelector('nav') as HTMLElement;
                if (nav) { nav.style.backgroundColor = color; }
            }, 200);
        }
    }
}
